import contactSG from '../data/contact-sg.json'
import contactUS from '../data/contact-us.json'
import contactDefault from '../data/contact.json'
import customerServiceSG from '../data/customer-service-sg.json'
import customerServiceUS from '../data/customer-service-us.json'
import customerServiceDefault from '../data/customer-service.json'
import faqSG from '../data/faq-sg.json'
import faqUS from '../data/faq-us.json'
import faqDefault from '../data/faq.json'
import privacyPolicySG from '../data/privacy-policy-sg.json'
import privacyPolicyUS from '../data/privacy-policy-us.json'
import privacyPolicyDefault from '../data/privacy-policy.json'
const faqDataMapping: Record<string, FAQ.FAQData> = {
  sg: faqSG,
  us: faqUS,
}
const contactDataMapping: Record<string, Contact.ContactData> = {
  sg: contactSG,
  us: contactUS,
}
const privacyPolicyDataMapping: Record<string, PrivacyPolicy.PrivacyData> = {
  sg: privacyPolicySG,
  us: privacyPolicyUS,
}
const customerServiceDataMapping: Record<string, Record<string, string>> = {
  sg: customerServiceSG,
  us: customerServiceUS,
}
export const loadFaqClientData = (country: string) => {
  const data = faqDataMapping[country] || faqDefault
  return data
}
export const loadContactClientData = (country: string) => {
  const data = contactDataMapping[country] || contactDefault
  return data
}
export const loadPrivacyPolicyClientData = (country: string) => {
  const data = privacyPolicyDataMapping[country] || privacyPolicyDefault
  return data
}

export const loadCustomerServiceClientData = (country: string) => {
  const data = customerServiceDataMapping[country] || customerServiceDefault
  return data
}
